// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__IiIVD","checkboxCol":"Table_checkboxCol__1yC7v","emailCol":"Table_emailCol__3aaNe","actionCol":"Table_actionCol__2mTat"};